import initialState from './ProductsInitialState';
import reducers from './ProductsReducer';

export default {
  initialState,
  reducers,
};
